// Services
import {HttpService} from '../services/HttpService'

// Enums
import {Language} from '../enums/Language'

// interfaces
import {AppUbersetzung} from '../interfaces/AppUbersetzung'

export class AppUbersetzungService {

    public static languageApiUrl?: string

    private static _instance;

    public static get instance() {
        if (!this._instance) {
            this._instance = new AppUbersetzungService()
        }
        return this._instance
    }

    private constructor() {

    }

    private readonly http: HttpService = HttpService.instance

    public async getAll(lang: Language, apps: string[]): Promise<AppUbersetzung> {

        let translations = {}
        
        for(const app of apps) {
            const response = await this.http.get<AppUbersetzung>(AppUbersetzungService.languageApiUrl + `${lang}/get/${app}`)

            translations = Object.assign({}, translations, response.body!)
        }     

        return translations
    }
}
